/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const deleteApiEmployeesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const deleteApiEmployeesId200Schema = z.any();

export const deleteApiEmployeesIdMutationResponseSchema = z.lazy(
  () => deleteApiEmployeesId200Schema,
);
